export enum SubtitleExtension {
  SRT = '.srt',
  SSA = '.ssa',
  VTT = '.vtt',
  TXT = '.txt'
}
